<template>
  <div class="col col-lg-3 col-md-4 col-sm-6 col-12">
    <EditNotificationModal
      v-if="showModal"
      :transfer="transfer"
      :filterId="null"
      @close="exitNotificationEdit"
    ></EditNotificationModal>
    <div id="notification-new" class="notification empty" @click="enterNotificationEdit">
      <i class="material-icons">add_circle_outline</i>
    </div>
  </div>
</template>

<script>
import baseController from '../../controllers/base'
import EditNotificationModal from './EditNotificationModal'

export default {
  extends: baseController,
  components: {
    EditNotificationModal
  },
  props: ['transfer'],
  data() {
    return { showModal: false }
  },
  methods: {
    enterNotificationEdit() {
      this.showModal = true
    },
    exitNotificationEdit() {
      this.showModal = false
      this.$emit('filtersChanged')
    }
  }
}
</script>
